module.exports = __webpack_public_path__ + "static/logo_relation_transparent-3e2ebd8be8f72e5e69ab15e56e01b453.png";